export class ResetPassword {
  password: string;
  confirmPassword: string;
  code: string;
}
